var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 5.63867C6.25263 5.63867 0 14.4998 0 14.4998C0 14.4998 6.25263 23.3609 14.5 23.3609C22.7474 23.3609 29 14.4998 29 14.4998C29 14.4998 22.7474 5.63867 14.5 5.63867ZM20.1389 14.4998C20.1389 17.6141 17.6143 20.1387 14.5 20.1387C11.3857 20.1387 8.86111 17.6141 8.86111 14.4998C8.86111 11.3855 11.3857 8.86089 14.5 8.86089C17.6143 8.86089 20.1389 11.3855 20.1389 14.4998ZM14.5 16.9164C15.8347 16.9164 16.9167 15.8345 16.9167 14.4998C16.9167 13.1651 15.8347 12.0831 14.5 12.0831C13.1653 12.0831 12.0833 13.1651 12.0833 14.4998C12.0833 15.8345 13.1653 16.9164 14.5 16.9164Z",
    fill: "#5F6F7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61769 3.81202C5.40416 3.02555 6.67928 3.02555 7.46576 3.81202L25.188 21.5342C25.9745 22.3207 25.9745 23.5958 25.188 24.3823C24.4015 25.1688 23.1264 25.1688 22.3399 24.3823L4.61769 6.66009C3.83121 5.87362 3.83121 4.5985 4.61769 3.81202Z",
    fill: "#5F6F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEyeIcon);
export default __webpack_public_path__ + "static/media/closed-eye-icon.61fd6ca232e3e8c76971ff34ab3ce8ef.svg";
export { ForwardRef as ReactComponent };